import { getAllSpecializations } from '../../../actions/specializations';
import { store } from '../../../index';

export function* onGetSpecializations() {
  const { dispatch } = store;
  dispatch(getAllSpecializations());
  yield true;
}
